import { useUpdateResidentStatusFlagsMutation } from "app/services/api/residentsApi";
import { useDisplayToast } from "ui/hooks/useDisplayToast";

export const useAssignStatusFlags = (onSuccess?: () => void) => {
  const { showNewToast, showErrorToast } = useDisplayToast();
  const [triggerAssignFlag, { isLoading: isAssigning }] =
    useUpdateResidentStatusFlagsMutation();

  const handleAssignFlags = async ({
    residentId,
    statusFlagIds,
  }: {
    residentId: number;
    statusFlagIds: number[];
  }) => {
    try {
      await triggerAssignFlag({
        id: residentId,
        body: { status_flag_ids: statusFlagIds },
      }).unwrap();

      showNewToast({
        title: "Status flags updated!",
        message: "The status flags were successfully assigned.",
        type: "success",
      });

      onSuccess?.();
    } catch (error) {
      showErrorToast(error);
    }
  };

  return {
    handleAssignFlags,
    isAssigning,
  };
};
